import { enableProdMode, importProvidersFrom } from '@angular/core';


import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { AdsenseModule } from 'ng2-adsense';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { CategoryService } from './app/services/category.service';
import { FwHttpService } from './app/services/fw-http.service';
import { ImageService } from './app/services/image.service';
import { LeafletService } from './app/services/leaflet.service';
import { LoggerService } from './app/services/logger.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, ReactiveFormsModule, AdsenseModule.forRoot({
            adClient: "ca-pub-8882259593968552",
            adSlot: 5169904810,
        })),
        FwHttpService, LoggerService, ImageService, CategoryService, LeafletService,
        provideRouter(routes, withInMemoryScrolling({
          anchorScrolling: "enabled",
          scrollPositionRestoration: "enabled",
        })),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
  .catch(err => console.log(err));
};


 if (document.readyState === 'complete') {
   bootstrap();
 } else {
   document.addEventListener('DOMContentLoaded', bootstrap);
 }

